module.exports = __webpack_public_path__ + "img/syllabus-boy-xl.15924688.png";